export default {
  data:()=>({
    pageHeight: 0,
  }),
  mounted() {
    this._onResize = () => this._resize();

    this._onResize();
    setTimeout(()=>{this._onResize();},250);
    setTimeout(()=>{this._onResize();},500);
    setTimeout(()=>{this._onResize();},1000);
    setTimeout(()=>{this._onResize();},2000);
    window.addEventListener('resize', this._onResize);
  },
  destroyed() {
    window.removeEventListener('resize', this._onResize);
  },
  methods:{
    _resize(){
      this.pageHeight = window.innerHeight-64;
    }
  }
}